/* Client-side product cards from /products/{handle}.js, using the <template data-purr-role="card-template">. */
(() => {
  'use strict';
  const Purr = window.Purr;
  if (Purr.renderCard) return;

  /* Detailed loader: distinguishes products that no longer exist (HTTP 404 – safe to forget) from transient
     failures (network error, 5xx, 429 – keep the handle). */
  Purr.loadProductsDetailed = async function loadProductsDetailed(handles) {
    const results = await Promise.all(handles.map(async (h) => {
      try {
        const res = await fetch(Purr.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js');
        if (res.status === 404) return { handle: h, product: null, missing: true };
        if (!res.ok) return { handle: h, product: null, failed: true };
        return { handle: h, product: await res.json() };
      } catch (e) { return { handle: h, product: null, failed: true }; }
    }));
    return {
      products: results.map((r) => r.product).filter(Boolean),
      missing: results.filter((r) => r.missing).map((r) => r.handle),
      failed: results.filter((r) => r.failed).map((r) => r.handle)
    };
  };

  Purr.loadProducts = async function loadProducts(handles) {
    return (await Purr.loadProductsDetailed(handles)).products;
  };

  Purr.renderCard = function renderCard(p) {
    const tpl = Purr.byRole('card-template');
    if (!tpl) return null;
    const el = tpl.content.firstElementChild.cloneNode(true);
    const url = Purr.routes.root.replace(/\/$/, '') + '/products/' + p.handle;
    el.dataset.handle = p.handle;
    const img = el.querySelector('[data-tpl-img]');
    if (img) {
      if (p.featured_image) {
        const base = p.featured_image.split('?')[0];
        img.src = base + '?width=600';
        img.srcset = [320, 480, 640, 960].map((w) => base + '?width=' + w + ' ' + w + 'w').join(', ');
        img.sizes = '(min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw';
      } else { img.remove(); }
      img.alt = p.title || '';
    }
    const type = el.querySelector('[data-tpl-type]');
    if (type && p.type) { type.textContent = p.type; type.hidden = false; }
    const link = el.querySelector('[data-tpl-link]'); link.href = url; link.textContent = p.title;
    const price = el.querySelector('[data-tpl-price]');
    const cur = el.querySelector('[data-tpl-price-current]');
    const cmp = el.querySelector('[data-tpl-price-compare]');
    const variant = (p.variants || []).find((v) => v.available) || (p.variants || [])[0];
    const minPrice = p.price_min != null ? p.price_min : (variant ? variant.price : p.price);
    cur.textContent = (p.price_varies ? (Purr.strings.from ? Purr.strings.from + ' ' : '') : '') + Purr.formatMoney(minPrice);
    if (p.compare_at_price_min && p.compare_at_price_min > minPrice) { cmp.textContent = Purr.formatMoney(p.compare_at_price_min); cmp.hidden = false; price.classList.add('purr-price--sale'); }
    const badges = el.querySelector('[data-tpl-badges]');
    if (badges && !p.available) { const b = document.createElement('span'); b.className = 'purr-badge purr-badge--soldout purr-badge--sm'; b.textContent = Purr.strings.soldOut; badges.appendChild(b); }
    const avail = el.querySelector('[data-tpl-avail]');
    if (avail) { avail.classList.add(p.available ? 'purr-avail--in' : 'purr-avail--out'); avail.textContent = p.available ? (Purr.strings.inStock || '') : (Purr.strings.soldOut || ''); if (!p.available) el.classList.add('purr-product-card--soldout'); if (!avail.textContent) avail.remove(); }
    const form = el.querySelector('[data-tpl-form]');
    const opts = el.querySelector('[data-tpl-options]');
    if (form) {
      if (!p.available) { form.remove(); if (opts) { opts.hidden = false; opts.href = url; opts.textContent = Purr.strings.soldOut; opts.setAttribute('aria-disabled', 'true'); } }
      else if ((p.variants || []).length > 1) { form.remove(); if (opts) { opts.hidden = false; opts.href = url; } }
      else { el.querySelector('[data-tpl-id]').value = variant.id; if (opts) opts.remove(); }
    }
    const wl = el.querySelector('[data-tpl-wishlist]');
    if (wl) wl.dataset.handle = p.handle;
    return el;
  };
})();
